export enum ActivityStatus {
  DRAFT = 'draft',
  REQUESTED = 'requested',
  RECEIVED = 'received',
  REJECTED = 'rejected',
  READY = 'ready',
  CANCELLED = 'cancelled',
  IN_PROGRESS = 'in-progress',
  ON_HOLD = 'on-hold',
  FAILED = 'failed',
  COMPLETED = 'completed',
  ENTERED_IN_ERROR = 'entered-in-error',
}
